import React from "react";
import { FaHome, FaUser, FaSignOutAlt, FaUsers } from "react-icons/fa";
import { routes } from "../../Routes/routers";
import { Link, useLocation } from "react-router-dom";

const navigationButtons = [
  { route: routes.home, icon: FaHome, label: "Início" },
  { route: routes.perfil, icon: FaUser, label: "Perfil" },
  { route: routes.team, icon: FaUsers, label: "Time" },
  { route: routes.login, icon: FaSignOutAlt, label: "Sair" },
];

export const BottomNavigation: React.FC = () => {
  const { pathname } = useLocation();

  return (
    <footer className="football-footer">
      <nav className="football-navigation" aria-label="Navegação principal">
        {navigationButtons.map(({ route, icon: Icon, label }) => (
          <Link
            key={route}
            to={route}
            className="football-navigation__item"
            aria-current={pathname === route ? "page" : undefined}
          >
            <span className="football-navigation__icon"><Icon aria-hidden="true" /></span>
            <span>{label}</span>
          </Link>
        ))}
      </nav>
    </footer>
  );
};
